import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KutaContainer = _resolveComponent("KutaContainer")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KutaContainer, { dictionary: _ctx.dictionary }, null, 8, ["dictionary"]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}